import { onInstallService } from './handlers/install'

export const SEGWARE_WIDGET = {
  id: 'SEGWARE_INTEGRATION',
  type: 'TOKEN',
  name: 'Integração com Segware',
  description: 'Criar integração com a Segware',
  color: '#ADD8E6',
  image: '/services/segware.png',
  categories: ['Monitoramento e Segurança Eletrônica'],
  service: 'segware',
  onClick: onInstallService,
  initialState: {
    name: 'Monitoramento e Segurança Eletrônica',
    data: {}
  }
}
